// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`ProjectReportDataOption model belongsTo relations 1`] = `
Array [
  "ProjectReport",
]
`;
